import { Project, Organization, ProjectFile, ProjectFolder, ProjectQuery, QueryStatus, ProjectRole, ProjectPermission, ProjectActivity, ProjectAction, ProjectLifecycle, ProjectStage, ProjectPriority, User, ProjectUser } from '../../types';

// Mock Organizations
export const mockOrganizations: Organization[] = [
  {
    id: 'org-1',
    name: 'Open AnaCapital',
    description: 'Primary investment organization',
    createdBy: '1',
    createdDate: '2024-01-15T10:00:00Z',
    updatedBy: '1',
    updatedDate: '2024-01-15T10:00:00Z',
    users: ['1', '2', '3', '4', '5'],
  },
  {
    id: 'org-2',
    name: 'Harvey AI Research',
    description: 'AI research and development division',
    createdBy: '2',
    createdDate: '2024-02-01T09:00:00Z',
    updatedBy: '2',
    updatedDate: '2024-02-01T09:00:00Z',
    users: ['2', '3', '4'],
  },
];

// Mock Project Files
const mockProjectFiles: ProjectFile[] = [
  {
    id: 'file-1',
    name: 'merger_agreement_draft.pdf',
    type: 'pdf',
    size: 2456789,
    uploadDate: '2024-06-28T14:30:00Z',
    updatedDate: '2024-06-28T14:30:00Z',
    uploadedBy: '1',
    path: '/documents/legal/',
    tags: ['legal', 'merger', 'draft'],
    metadata: { pages: 45, version: '1.2' },
  },
  {
    id: 'file-2',
    name: 'financial_model.xlsx',
    type: 'xlsx',
    size: 1234567,
    uploadDate: '2024-06-25T09:15:00Z',
    updatedDate: '2024-06-25T09:15:00Z',
    uploadedBy: '2',
    path: '/models/',
    tags: ['financial', 'model', 'analysis'],
    metadata: { sheets: 12, lastCalculated: '2024-06-25T09:15:00Z' },
  },
  {
    id: 'file-3',
    name: 'due_diligence_checklist.docx',
    type: 'docx',
    size: 567890,
    uploadDate: '2024-06-20T16:45:00Z',
    updatedDate: '2024-06-20T16:45:00Z',
    uploadedBy: '3',
    path: '/checklists/',
    tags: ['due-diligence', 'checklist'],
    metadata: { wordCount: 2500 },
  },
  {
    id: 'file-4',
    name: 'contract_analysis_report.pdf',
    type: 'pdf',
    size: 3456789,
    uploadDate: '2024-06-27T11:20:00Z',
    updatedDate: '2024-06-27T11:20:00Z',
    uploadedBy: '1',
    path: '/reports/',
    tags: ['contract', 'analysis', 'report'],
    metadata: { pages: 67, version: '2.1' },
  },
  {
    id: 'file-5',
    name: 'risk_assessment.xlsx',
    type: 'xlsx',
    size: 987654,
    uploadDate: '2024-06-26T15:30:00Z',
    updatedDate: '2024-06-26T15:30:00Z',
    uploadedBy: '2',
    path: '/assessments/',
    tags: ['risk', 'assessment'],
    metadata: { sheets: 8, lastCalculated: '2024-06-26T15:30:00Z' },
  },
  {
    id: 'file-6',
    name: 'compliance_checklist.docx',
    type: 'docx',
    size: 234567,
    uploadDate: '2024-06-24T09:45:00Z',
    updatedDate: '2024-06-24T09:45:00Z',
    uploadedBy: '3',
    path: '/compliance/',
    tags: ['compliance', 'checklist'],
    metadata: { wordCount: 1800 },
  },
  {
    id: 'file-7',
    name: 'market_research.pdf',
    type: 'pdf',
    size: 4567890,
    uploadDate: '2024-06-23T14:15:00Z',
    updatedDate: '2024-06-23T14:15:00Z',
    uploadedBy: '4',
    path: '/research/',
    tags: ['market', 'research'],
    metadata: { pages: 89, version: '1.0' },
  },
  {
    id: 'file-8',
    name: 'financial_projections.xlsx',
    type: 'xlsx',
    size: 1567890,
    uploadDate: '2024-06-22T10:30:00Z',
    updatedDate: '2024-06-22T10:30:00Z',
    uploadedBy: '2',
    path: '/projections/',
    tags: ['financial', 'projections'],
    metadata: { sheets: 15, lastCalculated: '2024-06-22T10:30:00Z' },
  },
];

// Mock Project Folders
const mockProjectFolders: ProjectFolder[] = [
  {
    id: 'folder-1',
    name: 'Legal Documents',
    createdBy: '1',
    createdDate: '2024-06-01T10:00:00Z',
    updatedDate: '2024-06-28T14:30:00Z',
    path: '/documents/legal/',
    fileCount: 15,
    is_folder: true,
    children: [],
  },
  {
    id: 'folder-2',
    name: 'Financial Models',
    createdBy: '2',
    createdDate: '2024-06-01T10:00:00Z',
    updatedDate: '2024-06-25T09:15:00Z',
    path: '/models/',
    fileCount: 8,
    is_folder: true,
    children: [],
  },
  {
    id: 'folder-3',
    name: 'Due Diligence',
    createdBy: '3',
    createdDate: '2024-06-01T10:00:00Z',
    updatedDate: '2024-06-20T16:45:00Z',
    path: '/due-diligence/',
    fileCount: 23,
    is_folder: true,
    children: [],
  },
  {
    id: 'folder-4',
    name: 'Reports',
    createdBy: '1',
    createdDate: '2024-06-02T11:00:00Z',
    updatedDate: '2024-06-27T11:20:00Z',
    path: '/reports/',
    fileCount: 12,
    is_folder: true,
    children: [],
  },
  {
    id: 'folder-5',
    name: 'Risk Assessments',
    createdBy: '2',
    createdDate: '2024-06-03T09:30:00Z',
    updatedDate: '2024-06-26T15:30:00Z',
    path: '/assessments/',
    fileCount: 6,
    is_folder: true,
    children: [],
  },
  {
    id: 'folder-6',
    name: 'Compliance',
    createdBy: '3',
    createdDate: '2024-06-04T14:20:00Z',
    updatedDate: '2024-06-24T09:45:00Z',
    path: '/compliance/',
    fileCount: 18,
    is_folder: true,
    children: [],
  },
];

// Mock Project Queries
const mockProjectQueries: ProjectQuery[] = [
  {
    id: 'query-1',
    name: 'Contract Risk Analysis',
    description: 'Analyze contracts for high-risk clauses and terms',
    query: 'SELECT * FROM contracts WHERE risk_level = "high"',
    createdBy: '1',
    createdDate: '2024-06-28T11:00:00Z',
    lastRun: '2024-06-28T11:30:00Z',
    status: QueryStatus.Completed,
    tags: ['risk', 'contracts'],
    results: { rowCount: 15, executionTime: '2.3s' },
    executionTime: 2300,
  },
  {
    id: 'query-2',
    name: 'Revenue Projections',
    description: 'Extract revenue projections from financial documents',
    query: 'SELECT year, projected_revenue FROM financial_data ORDER BY year',
    createdBy: '2',
    createdDate: '2024-06-25T14:20:00Z',
    lastRun: '2024-06-25T14:25:00Z',
    status: QueryStatus.Completed,
    tags: ['revenue', 'projections'],
    results: { rowCount: 5, executionTime: '1.1s' },
    executionTime: 1100,
  },
  {
    id: 'query-3',
    name: 'Compliance Violations',
    description: 'Identify potential compliance violations in documents',
    query: 'SELECT document_id, violation_type FROM compliance_scan WHERE severity = "critical"',
    createdBy: '3',
    createdDate: '2024-06-24T16:00:00Z',
    lastRun: '2024-06-24T16:05:00Z',
    status: QueryStatus.Failed,
    tags: ['compliance', 'violations'],
    results: { error: 'Query timeout after 30 seconds' },
    executionTime: 30000,
  },
  {
    id: 'query-4',
    name: 'Document Classification',
    description: 'Classify documents by type and importance',
    query: 'SELECT document_type, COUNT(*) as count FROM documents GROUP BY document_type',
    createdBy: '1',
    createdDate: '2024-06-23T09:15:00Z',
    lastRun: '2024-06-23T09:20:00Z',
    status: QueryStatus.Running,
    tags: ['classification', 'documents'],
    results: null,
    executionTime: undefined,
  },
  {
    id: 'query-5',
    name: 'Key Terms Extraction',
    description: 'Extract key terms and definitions from legal documents',
    query: 'EXTRACT key_terms FROM legal_documents WHERE document_type = "contract"',
    createdBy: '2',
    createdDate: '2024-06-22T13:30:00Z',
    lastRun: undefined,
    status: QueryStatus.Pending,
    tags: ['extraction', 'terms'],
    results: null,
    executionTime: undefined,
  },
  {
    id: 'query-6',
    name: 'Financial Metrics Summary',
    description: 'Summarize key financial metrics across all documents',
    query: 'SELECT metric_name, AVG(value) as avg_value FROM financial_metrics GROUP BY metric_name',
    createdBy: '4',
    createdDate: '2024-06-21T11:45:00Z',
    lastRun: '2024-06-21T11:50:00Z',
    status: QueryStatus.Completed,
    tags: ['financial', 'metrics'],
    results: { rowCount: 12, executionTime: '0.8s' },
    executionTime: 800,
  },
];


// Mock Users for Projects
const mockProjectUsersData: User[] = [
    { id: '1', name: 'Alice', email: 'alice@example.com', is_active: true },
    { id: '2', name: 'Bob', email: 'bob@example.com', is_active: true },
    { id: '3', name: 'Charlie', email: 'charlie@example.com', is_active: true },
    { id: '4', name: 'David', email: 'david@example.com', is_active: true },
    { id: '5', name: 'Eve', email: 'eve@example.com', is_active: false },
];

// Mock Project Users (linking users and roles to projects)
const mockProjectUsers: ProjectUser[] = [
  {
    id: 'pu-1',
    project_id: 'project-1',
    user_id: '2',
    role_id: 'role-2',
    user: mockProjectUsersData[1], // Bob
    role: "", // Editor
  },
  {
    id: 'pu-2',
    project_id: 'project-1',
    user_id: '3',
    role_id: 'role-3',
    user: mockProjectUsersData[2], // Charlie
    role: "", // Viewer
  },
  {
    id: 'pu-3',
    project_id: 'project-2',
    user_id: '4',
    role_id: 'role-1',
    user: mockProjectUsersData[3], // David
    role: "", // Admin
  },
    {
    id: 'pu-4',
    project_id: 'project-4',
    user_id: '2',
    role_id: 'role-2',
    user: mockProjectUsersData[1],
    role: "",
  },
  {
    id: 'pu-5',
    project_id: 'project-4',
    user_id: '3',
    role_id: 'role-3',
    user: mockProjectUsersData[2],
    role: "",
  },
  {
    id: 'pu-6',
    project_id: 'project-5',
    user_id: '2',
    role_id: 'role-1',
    user: mockProjectUsersData[1],
    role: "",
  },
  {
    id: 'pu-7',
    project_id: 'project-7',
    user_id: '3',
    role_id: 'role-2',
    user: mockProjectUsersData[2],
    role: "",
  },
  {
    id: 'pu-8',
    project_id: 'project-7',
    user_id: '4',
    role_id: 'role-3',
    user: mockProjectUsersData[3],
    role: "",
  },
  {
    id: 'pu-9',
    project_id: 'project-8',
    user_id: '2',
    role_id: 'role-2',
    user: mockProjectUsersData[1],
    role: "",
  },
];

// Mock Projects
export const mockProjects: Project[] = [
  {
    id: 'project-1',
    name: 'TechCorp Acquisition Analysis',
    description: 'Due diligence and analysis for TechCorp acquisition deal',
    organizationId: 'org-1',
    dealId: 'deal-1', // Associated with TechCorp Acquisition deal
    ownerId: '1', // Project owner
    createdBy: '1',
    createdDate: '2024-06-28T10:00:00Z',
    updatedBy: '1',
    updatedDate: '2024-06-28T15:30:00Z',
    lifecycle: ProjectLifecycle.InProcess,
    stage: ProjectStage.Execution,
    tags: ['acquisition', 'due-diligence', 'technology'],
    isPrivate: false,
    users: [mockProjectUsers[0], mockProjectUsers[1]],
    files: mockProjectFiles.slice(0, 2),
    folders: mockProjectFolders.slice(0, 2),
    queries: [mockProjectQueries[0]],
    fileCount: 111,
    queryCount: 1,
    totalSize: 123456789, // 118.03 MB
    priority: ProjectPriority.High,
    estimatedCompletionDate: '2024-09-15T00:00:00Z',
    budget: 500000,
    currency: 'USD',
  },
  {
    id: 'project-2',
    name: 'GreenEnergy Investment DD',
    description: 'Due diligence for GreenEnergy Series B investment',
    organizationId: 'org-1',
    dealId: 'deal-2', // Associated with GreenEnergy Investment deal
    ownerId: '2', // Different owner than creator
    createdBy: '2',
    createdDate: '2024-04-22T09:00:00Z',
    updatedBy: '2',
    updatedDate: '2024-04-22T16:45:00Z',
    lifecycle: ProjectLifecycle.Completed,
    stage: ProjectStage.Closure,
    tags: ['investment', 'clean-energy', 'due-diligence'],
    isPrivate: false,
    users: [mockProjectUsers[2]],
    files: [mockProjectFiles[2]],
    folders: [mockProjectFolders[2]],
    queries: [],
    fileCount: 48,
    queryCount: 7,
    totalSize: 67890123, // 64.86 MB
    priority: ProjectPriority.Medium,
    estimatedCompletionDate: '2024-08-30T00:00:00Z',
    actualCompletionDate: '2024-04-22T16:45:00Z',
    completedDate: '2024-04-22T16:45:00Z',
    budget: 200000,
    currency: 'USD',
  },
  {
    id: 'project-3',
    name: 'RetailChain Merger Analysis',
    description: 'Comprehensive analysis for RetailChain merger opportunity',
    organizationId: 'org-1',
    dealId: 'deal-3', // Associated with RetailChain Merger deal
    ownerId: '3',
    createdBy: '3',
    createdDate: '2024-06-14T08:30:00Z',
    updatedBy: '3',
    updatedDate: '2024-06-14T17:20:00Z',
    lifecycle: ProjectLifecycle.Archived,
    stage: ProjectStage.Closure,
    tags: ['merger', 'retail', 'analysis'],
    isPrivate: true,
    users: [],
    files: mockProjectFiles,
    folders: mockProjectFolders,
    queries: mockProjectQueries,
    fileCount: 10,
    queryCount: 1,
    totalSize: 98765432, // 94.28 KB
    priority: ProjectPriority.High,
    estimatedCompletionDate: '2024-07-31T00:00:00Z',
    actualCompletionDate: '2024-06-14T17:20:00Z',
    completedDate: '2024-06-14T17:20:00Z',
    archivedDate: '2024-06-20T10:00:00Z',
    archivedBy: '3',
    budget: 300000,
    currency: 'USD',
  },
  {
    id: 'project-4',
    name: 'PropTech Venture Planning',
    description: 'Strategic planning for PropTech joint venture',
    organizationId: 'org-1',
    dealId: 'deal-4', // Associated with PropTech Venture deal
    ownerId: '4',
    createdBy: '4',
    createdDate: '2024-04-21T11:15:00Z',
    updatedBy: '4',
    updatedDate: '2024-04-21T14:30:00Z',
    lifecycle: ProjectLifecycle.InProcess,
    stage: ProjectStage.Planning,
    tags: ['joint-venture', 'proptech', 'planning'],
    isPrivate: false,
    users: [mockProjectUsers[3], mockProjectUsers[4]],
    files: [],
    folders: [],
    queries: Array.from({ length: 6 }, (_, i) => ({
      ...mockProjectQueries[0],
      id: `query-cytk-${i + 1}`,
      name: `PropTech Query ${i + 1}`,
    })),
    fileCount: 300,
    queryCount: 6,
    totalSize: 224567890, // 214.45 MB
    priority: ProjectPriority.Medium,
    estimatedCompletionDate: '2024-10-15T00:00:00Z',
    budget: 150000,
    currency: 'USD',
  },
  {
    id: 'project-5',
    name: 'Manufacturing Divestiture',
    description: 'Asset divestiture project for manufacturing division',
    organizationId: 'org-1',
    dealId: 'deal-5', // Associated with Manufacturing Divestiture deal
    ownerId: '1',
    createdBy: '5',
    createdDate: '2024-01-15T13:45:00Z',
    updatedBy: '1',
    updatedDate: '2024-05-30T17:00:00Z',
    lifecycle: ProjectLifecycle.Completed,
    stage: ProjectStage.Closure,
    tags: ['divestiture', 'manufacturing', 'closed'],
    isPrivate: false,
    users: [mockProjectUsers[5]],
    files: [],
    folders: [],
    queries: Array.from({ length: 5 }, (_, i) => ({
      ...mockProjectQueries[1],
      id: `query-sandbox-${i + 1}`,
      name: `Divestiture Query ${i + 1}`,
    })),
    fileCount: 102,
    queryCount: 5,
    totalSize: 79012345, // 75.60 MB
    priority: ProjectPriority.Critical,
    estimatedCompletionDate: '2024-05-30T00:00:00Z',
    actualCompletionDate: '2024-05-30T17:00:00Z',
    completedDate: '2024-05-30T17:00:00Z',
    budget: 750000,
    currency: 'USD',
  },
  {
    id: 'project-6',
    name: 'Market Research Initiative',
    description: 'Comprehensive market research for new investment sectors',
    organizationId: 'org-1',
    ownerId: '1',
    createdBy: '1',
    createdDate: '2024-09-10T10:20:00Z',
    updatedBy: '1',
    updatedDate: '2024-09-10T15:45:00Z',
    lifecycle: ProjectLifecycle.InProcess,
    stage: ProjectStage.Initiation,
    tags: ['market-research', 'analysis', 'sectors'],
    isPrivate: true,
    users: [],
    files: [],
    folders: [],
    queries: [mockProjectQueries[0]],
    fileCount: 10,
    queryCount: 1,
    totalSize: 94567890, // 90.20 MB
    priority: ProjectPriority.Low,
    estimatedCompletionDate: '2024-12-15T00:00:00Z',
    budget: 100000,
    currency: 'USD',
  },
  {
    id: 'project-7',
    name: 'Executive Orders Analysis',
    description: 'Analysis of executive orders and regulatory changes',
    organizationId: 'org-2',
    ownerId: '2',
    createdBy: '2',
    createdDate: '2024-04-30T09:30:00Z',
    updatedBy: '2',
    updatedDate: '2024-04-30T16:15:00Z',
    lifecycle: ProjectLifecycle.InProcess,
    stage: ProjectStage.Monitoring,
    tags: ['executive-orders', 'regulatory', 'compliance'],
    isPrivate: false,
    users: [mockProjectUsers[6], mockProjectUsers[7]],
    files: [],
    folders: [],
    queries: [],
    fileCount: 300,
    queryCount: 6,
    totalSize: 214567890, // 204.65 MB
    priority: ProjectPriority.Medium,
    estimatedCompletionDate: '2024-11-30T00:00:00Z',
    budget: 80000,
    currency: 'USD',
  },
  {
    id: 'project-8',
    name: 'Samsung Patents Research',
    description: 'Patent analysis and intellectual property research for Samsung',
    organizationId: 'org-2',
    ownerId: '3',
    createdBy: '3',
    createdDate: '2024-04-29T14:00:00Z',
    updatedBy: '3',
    updatedDate: '2024-04-29T18:30:00Z',
    lifecycle: ProjectLifecycle.Archived,
    stage: ProjectStage.Closure,
    tags: ['samsung', 'patents', 'ip', 'research'],
    isPrivate: false,
    users: [mockProjectUsers[8]],
    files: [],
    folders: [],
    queries: [],
    fileCount: 102,
    queryCount: 5,
    totalSize: 75012345, // 71.54 MB
    priority: ProjectPriority.Low,
    estimatedCompletionDate: '2024-06-30T00:00:00Z',
    actualCompletionDate: '2024-04-29T18:30:00Z',
    completedDate: '2024-04-29T18:30:00Z',
    archivedDate: '2024-05-15T12:00:00Z',
    archivedBy: '3',
    budget: 120000,
    currency: 'USD',
  },
];

// Mock Project Permissions
export const mockProjectPermissions: ProjectPermission[] = [
  {
    id: 'perm-1',
    projectId: 'project-1',
    userId: '2',
    role: ProjectRole.Editor,
    grantedBy: '1',
    grantedDate: '2024-06-28T10:30:00Z',
  },
  {
    id: 'perm-2',
    projectId: 'project-1',
    userId: '3',
    role: ProjectRole.Viewer,
    grantedBy: '1',
    grantedDate: '2024-06-28T10:35:00Z',
  },
  {
    id: 'perm-3',
    projectId: 'project-2',
    userId: '1',
    role: ProjectRole.Admin,
    grantedBy: '2',
    grantedDate: '2024-04-22T09:15:00Z',
  },
];

// Mock Project Activities
export const mockProjectActivities: ProjectActivity[] = [
  {
    id: 'activity-1',
    projectId: 'project-1',
    userId: '1',
    action: ProjectAction.Created,
    timestamp: '2024-06-28T10:00:00Z',
    details: 'Created project "Merger Agreements"',
  },
  {
    id: 'activity-2',
    projectId: 'project-1',
    userId: '1',
    action: ProjectAction.FileUploaded,
    timestamp: '2024-06-28T14:30:00Z',
    details: 'Uploaded file "merger_agreement_draft.pdf"',
    entityType: 'file',
    entityId: 'file-1',
  },
  {
    id: 'activity-3',
    projectId: 'project-1',
    userId: '1',
    action: ProjectAction.QueryCreated,
    timestamp: '2024-06-28T11:00:00Z',
    details: 'Created query "Contract Risk Analysis"',
    entityType: 'query',
    entityId: 'query-1',
  },
  {
    id: 'activity-4',
    projectId: 'project-1',
    userId: '1',
    action: ProjectAction.Shared,
    timestamp: '2024-06-28T10:30:00Z',
    details: 'Shared project with user-2 (Editor role)',
  },
];

// Helper functions
export const getProjectsByOrganization = (organizationId: string): Project[] => {
  return mockProjects.filter(project => project.organizationId === organizationId);
};

export const getProjectsByUser = (userId: string): Project[] => {
  return mockProjects.filter(project => 
    project.createdBy === userId || 
    project.ownerId === userId ||
    project.users.some(member => member.user_id === userId && member.user.is_active) ||
    (project.sharedWith && project.sharedWith.includes(userId))
  );
};

export const getSharedProjects = (userId: string): Project[] => {
  return mockProjects.filter(project => 
    (project.users.some(member => member.user_id === userId && member.user.is_active) ||
     (project.sharedWith && project.sharedWith.includes(userId))) && 
    project.createdBy !== userId
  );
};

export const getUserProjects = (userId: string): Project[] => {
  return mockProjects.filter(project => project.createdBy === userId);
};

export const getProjectsByDeal = (dealId: string): Project[] => {
  return mockProjects.filter(project => project.dealId === dealId);
};

export const getActiveProjects = (): Project[] => {
  return mockProjects.filter(project => 
    project.lifecycle === ProjectLifecycle.InProcess
  );
};

export const getProjectsByLifecycle = (lifecycle: ProjectLifecycle): Project[] => {
  return mockProjects.filter(project => project.lifecycle === lifecycle);
};


export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  
  if (date >= startOfToday) {
    return 'Today';
  } else if (date >= startOfYesterday) {
    return 'Yesterday';
  }

  const diffTime = Math.abs(now.getTime() - date.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7);
    return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  } else if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `${months} month${months > 1 ? 's' : ''} ago`;
  } else {
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  }
};
